// extracted by mini-css-extract-plugin
module.exports = {"add-button":"GroupHierarchy_add-button__2Wj_M","delete-button":"GroupHierarchy_delete-button__2l4OP"};